import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import {FaIcon} from '../../FaIcon';
import {ActivityLogEntryList} from '../activity_log/ActivityLogEntryList';

export function ActivityLogPreviewBox({clientId, entries, loading, onAddNote}) {
    const {t} = useTranslation();

    const isEmpty = !loading && (!entries || entries.length === 0);
    const hasEntries = !loading && entries && entries.length > 0;

    return (
        <div className="box activity-log-preview-box">
            <div className="activity-log-preview-header">
                <h3 className="activity-log-preview-title">{t('control_central.activity_log_title')}</h3>
                <button className="cc-action-button -small" onClick={onAddNote}>
                    <FaIcon iconName="plus"/>
                    {t('control_central.activity_log_add_note')}
                </button>
            </div>

            {isEmpty ? (
                <div className="cc-empty-state">
                    <FaIcon iconName="history"/>
                    <p>{t('control_central.activity_log_empty')}</p>
                    <button className="btn -alt -small" onClick={onAddNote}>
                        <FaIcon iconName="plus"/>
                        {t('control_central.activity_log_empty_cta')}
                    </button>
                </div>
            ) : (
                <div className="activity-log-preview-scroll">
                    <ActivityLogEntryList entries={entries} loading={loading} clientId={clientId}/>
                    {hasEntries && (
                        <div className="activity-log-preview-footer">
                            <Link className="cc-action-button -small" to={`/client/${clientId}/activity-log`}>
                                {t('control_central.activity_log_see_all_short')}
                            </Link>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
